import { DevelioAuthProvider, OrgAutoActivator } from '@develio/auth/client';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { FeatureProvider } from './lib/features';
import { router } from './router';
import './index.css';

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string | undefined;

if (!PUBLISHABLE_KEY) {
  // eslint-disable-next-line no-console
  console.warn(
    '[develio/web] VITE_CLERK_PUBLISHABLE_KEY is not set. ' +
      'Sign-in and user menus will not work. Set it in .env.local.',
  );
}

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <DevelioAuthProvider publishableKey={PUBLISHABLE_KEY ?? 'pk_test_missing'}>
      <OrgAutoActivator />
      <FeatureProvider>
        <RouterProvider router={router} />
      </FeatureProvider>
    </DevelioAuthProvider>
  </React.StrictMode>,
);
